import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const home = user?.role === 'admin' ? '/admin' : user?.role === 'company' ? '/company' : user ? '/student' : '/';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold text-blue-100 mb-2 select-none">404</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Sayfa Bulunamadı</h1>
        <p className="text-gray-500 text-sm mb-8">
          Aradığınız sayfa mevcut değil ya da taşınmış olabilir.
        </p>
        <button
          onClick={() => navigate(home)}
          className="px-6 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
        >
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default NotFound;
